import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import "../assets/css/Testimonials.css";
import carlos from "../assets/img/Carlos.png";
import solange from "../assets/img/Solange.png";
import ludesberg from "../assets/img/Ludesberg.png";
import aspas from "../assets/img/subtitle.svg";
import imgcard1 from "../assets/img/imgCardTestimonials01.jpg";
import imgcard2 from "../assets/img/imgCardTestimonials02.jpg";
import imgcard3 from "../assets/img/imgCardTestimonials03.jpg";


const testimonialsData = [
  {
    imgSrc: carlos,
    imgAlt: "Carlos Alberto Daniel",
    text: "“A GAO TECH se diferencia pela sua capacidade de entender as necessidades do nosso negócio e entregar soluções tecnológicas inovadoras. A equipe é extremamente competente e comprometida.”",
    name: "Carlos Alberto Daniel",
    position: "Diretor na MD COR TINTAS",
  },
//   {
//     imgSrc: ludesberg,
//     imgAlt: "Ludenberg Vieira Sousa Rocha",
//     text: "“Uma empresa sólida, comprometida com resultados excepcionais, sempre superando as expectativas e entregando o melhor em cada oportunidade!”",
//     name: "Ludenberg Vieira Sousa Rocha",
//     position: "Gerente de TI no SEBRAE/RR",
//   },
  {
    imgSrc: solange,
    imgAlt: "Solange Silva da Mata",
    text: "“A GAO se destaca pela excelência no atendimento, oferecendo qualidade e entregas dentro dos prazos estabelecidos.”",
    name: "Solange Silva da Mata",
    position: "Superintendente na BRB Corretora de Seguros S.A.",
  },
];



const TestimonialCard = ({ imgSrc, imgAlt, text, name, position }) => (

<div className="card-575-responsive   bg-white ">
    <div className="d-flex ">
        <img className="img-size-card-testimonials" src={imgSrc} alt={imgAlt} />
        <div className="text-start">
            <div className="card-testimonials-title"> {name} </div>
            <div className="">{position} </div>
        </div>
    </div>
    <div className="description-card-testimonials text-start">
        {text}
    </div>
</div>
);

const Testimonials = () => (
  <section className="container-fluid   bg-dg-testimonials">
    <div className="row">
      <div className="text-start   padding-sides-testimonials">O que os clientes estão dizendo </div>
      <div className="text-start   padding-sides-testimonials-dowm">sobre a GAO TECH ? </div>
    </div>
    <div className="row  padding-dowm">
        <div className="padding-sides-testimonials-card   ">
            <div className="card-section">
                <Swiper
                    slidesPerView={1.5}
                    spaceBetween={1}
                    navigation={true}
                    modules={[Navigation]}
                    className="mySwiper"
                    breakpoints={{
                        0: {
                            slidesPerView: 1,
                            spaceBetween: 0,
                        },
                        900: {
                            slidesPerView: 3,
                            spaceBetween: 0,
                        },
                    }}
                >
                    {testimonialsData.map((testimonial, index) => (
                        <SwiperSlide key={index}>
                            <TestimonialCard {...testimonial} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

        </div>
    </div>




  </section>
);

export default Testimonials;
